import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import 'animate.css';
import './assets/style/common.scss' // 公共css
import zhLocale from 'element-plus/es/locale/lang/zh-cn'
const app = createApp(App)
app.use(router)
app.use(store)
app.use(ElementPlus, {
  locale: zhLocale
})
app.mount('#app')
